import { createSlice } from "@reduxjs/toolkit";

import {
  getAgreementThunk,
  createAgreementThunk,
  updateAgreementThunk,
  deleteAgreementThunk,
} from "state/action/agreement";

// Initial state
const initialState = {
  // Get Agreement inisial state
  getAgreement: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createAgreementInputBody: {
    agreement_no: "",
    tenant: "",
    type: "",
    lease_type: "",
    leased_item: [],
    documents: [],
    lease_terms: {
      rentalFee: "",
      deposit: "",
      paymentTerms: "",
      status: "",
    },
    additional_services: "",
    payment_records: [],
  },
  // Create Agreement inisial state
  createAgreement: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Agreement inisial state
  updateAgreement: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Agreement inisial state
  deleteAgreement: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Agreement object value
  agreement_object_value: "",
};

export const agreementSlice = createSlice({
  name: "agreement",
  initialState,
  reducers: {
    setGetAgreementObjectValue: (state, action) => {
      return {
        ...state,
        agreement_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetAgreementObjectValue: (state, _) => {
      return {
        ...state,
        agreement_object_value: "",
      };
    },
    setClearGetAgreement: (state, _) => {
      return {
        ...state,
        getAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateAgreement: (state, _) => {
      return {
        ...state,
        createAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateAgreement: (state, _) => {
      return {
        ...state,
        updateAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteAgreement: (state, _) => {
      return {
        ...state,
        deleteAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setCreateOfferAgreementInputBody: (state, action) => {
      return {
        ...state,
        createOfferAgreementInputBody: action.payload,
      };
    },
    setClearCreateOfferAgreementInputBody: (state, _) => {
      return {
        ...state,
        createOfferAgreementInputBody: {
          transaction_type: "",
          department: "",
          type: "",
          agreement_no: "",
          offer_date: "",
          start_date: "",
          currency: "",
          end_date: "",
          fittingOut_date: "",
          handOver_date: "",
          followUp_date: "",
          status: "",
          tenant: null,
          billing: null,
          salesman_id: "",
          property: "",
          building: "",
          unit: null,
          charge_mode: "",
          note: "",
          fixed_rate: "",
        },
      };
    },
    setCreateAgreementInputBody: (state, action) => {
      return {
        ...state,
        createAgreementInputBody: action.payload,
      };
    },
    setClearSignAgreementInputBody: (state, _) => {
      return {
        ...state,
        createAgreementInputBody: {
          agreement_template_number: "",
          tenant: "",
          type: "",
          lease_type: "",
          leased_item: [],
          documents: [],
          lease_terms: {
            startDate: "",
            endDate: "",
            rentalFee: "",
            deposit: "",
            paymentTerms: "",
            status: "",
          },
          additional_services: "",
          payment_records: [],
        },
      };
    },
    setClearAllAgreementState: (state, _) => {
      return {
        ...state,
        // Get Agreement inisial state
        getAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Agreement inisial state
        createAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Agreement inisial state
        updateAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Agreement inisial state
        deleteAgreement: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Agreement object value
        agreement_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Agreement reducer
      .addCase(getAgreementThunk.pending, (state, _) => {
        return {
          ...state,
          getAgreement: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getAgreementThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getAgreement: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getAgreementThunk.rejected, (state, action) => {
        return {
          ...state,
          getAgreement: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Agreement reducer
      .addCase(createAgreementThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createAgreementThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createAgreementThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Agreement reducer
      .addCase(updateAgreementThunk.pending, (state, _) => {
        return {
          ...state,
          updateAgreement: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateAgreementThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateAgreement: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateAgreementThunk.rejected, (state, action) => {
        return {
          ...state,
          updateAgreement: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const agreementAction = {
  ...agreementSlice.actions,
  getAgreementThunk,
  createAgreementThunk,
  updateAgreementThunk,
  deleteAgreementThunk,
};

export function selectAgreementObjectValue(state) {
  return state?.agreement?.agreement_object_value;
}

export function selectAgreement(state) {
  return state?.agreement;
}

export default agreementSlice.reducer;
